import axios from 'axios';

export interface Application {
  macId: string;
  name: string;
}

export interface ApplicationRepository {
  name: string;
  link: string;
  [key: string]: unknown;
}

const BASE_URL = `${import.meta.env.APP_SCANCODE_API_URL ?? 'https://api-cdt.maersk.com/aliancaapps-scancodecdt'}/api/applications`;

/**
 * Fetches the list of applications from the ScanCode CDT API.
 * The Bearer token is automatically injected by the Axios interceptor (MSAL).
 * Returns objects with `macid` (for future use) and `name` (displayed in the UI).
 */
export const applicationsApi = {
  getApplications: (): Promise<Application[]> =>
    axios.get<Application[]>(BASE_URL).then((r) => r.data),

  /**
   * Fetches repositories for a given application by its macid.
   * Example: GET /api/applications/A3538/repositories
   */
  getRepositoriesByMacid: (macid: string): Promise<ApplicationRepository[]> =>
    axios.get<ApplicationRepository[]>(`${BASE_URL}/${macid}/repositories`).then((r) => r.data),
};
